import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface TooltipWithHeaderProps {
  title: string | null
  description: React.ReactNode
}
type IconHeaderPros = TooltipWithHeaderProps

const TooltipWithHeader = ({ title, description }: TooltipWithHeaderProps) => {
  return (
    <Box gap="s8" textAlign="center" background="grey800" alignItems="center">
      <Text.Header3>{title}</Text.Header3>
      {description}
    </Box>
  )
}

const IconHeader = ({ title, description }: IconHeaderPros) => {
  const [open, toggle] = useToggle()

  if (title === null && description === null) {
    return null
  }

  return (
    <Box flexDirection="row" gap="s4" alignItems="center">
      <Tooltip.ItemList
        attachment="bottom center"
        targetAttachment="top center"
        open={open}
        toggle={toggle}
      >
        <Icon.Small color="grey000White" icon="info" encircled="grey600" />
        <TooltipWithHeader title={title} description={description} />
      </Tooltip.ItemList>
    </Box>
  )
}

export default IconHeader
